// src/screens/sales/complexOrder/ComplexOrder.tsx

import React from 'react'
import classes from './ComplexOrder.module.sass'
import { Helmet } from 'react-helmet-async'
import { List } from './components/list/List'
import { Modal } from '../../../common/components/modal/Modal'
import { Form } from './components/form/Form'
import { Details } from './components/details/Details'
import { useComplexOrder } from './hooks/useComplexOrder'
import Search from '../../../common/components/listControl/search/Search'
import { useSearchWithDebounce } from '../../../common/hooks/useSearchWithDebounce'
import { Button } from '../../../common/components/button/Button'

export const ComplexOrder = () => {
  const {
    getList,
    modalActive,
    setModalActive,
    startEdit,
    edit,
    data,
    setData,
    list,
    detailsModalActive,
    setDetailsModalActive,
    showDetails,
    current,
    initialData,
    startCreate,
    loading,
  } = useComplexOrder()

  const {
    searchQuery,
    handleSearch,
    clearSearch,
    filteredItems: filteredList,
  } = useSearchWithDebounce({
    items: list,
    searchFields: ['phone_number', 'customerName', 'id'],
  })

  return (
    <div className={classes.container}>
      <Helmet>
        <title>{`Проектные заявки`}</title>
        <meta name="description" content={`Проектные заявки`} />
      </Helmet>
      <div className={classes.titleWithButtons}>
        <div className={classes.header}>{`проектные заявки`}</div>
        <Button onClick={startCreate} text="Создать" />
      </div>
      <div className={classes.searchContainer}>
        <Search
          onChange={handleSearch}
          clear={clearSearch}
          value={searchQuery}
          placeHolder="Поиск по телефону, имени или ID"
        />
      </div>
      <List showDetails={showDetails} startEdit={startEdit} list={filteredList} loading={loading} />
      <Modal modalActive={modalActive} setModalActive={setModalActive}>
        <Form
          edit={edit}
          data={data}
          setData={setData}
          getList={getList}
          setModalActive={setModalActive}
          el={current}
          initialData={initialData}
          modalActive={modalActive}
        />
      </Modal>
      <Modal modalActive={detailsModalActive} setModalActive={setDetailsModalActive}>
        <Details el={current} onEdit={startEdit} />
      </Modal>
    </div>
  )
}
